// extracted by mini-css-extract-plugin
module.exports = {"weekly-class-day":"WeeklyClass_weekly-class-day__3WBMM"};